<template>
  <div class="c-annotator__wrapper annotator-adder annotator-hide">
    <button class="c-annotator__button hl" type="button" @click.prevent="clickHighlight()">
      <highlight-icon />
      {{ $t('ANNOTATOR_HIGHLIGHT' ) }}
    </button>
    <button class="c-annotator__button" type="button" @click.prevent="clickAddNote()">
      <note-add-icon />
      {{ $t('ANNOTATOR_ADD_NOTE' ) }}
    </button>
    <button class="c-annotator__button lookup" type="button" @click.prevent="clickLookup()">
      <lookup-icon />
      {{ $t('ANNOTATOR_LOOK_UP' ) }}
    </button>
  </div>
</template>

<script>
import NoteAdd from '@/assets/svg/NoteAdd'
import HighlightIcon from '@/assets/svg/HighlightsIcon'
import LookupIcon from '@/assets/svg/LookupIcon'
import i18n from '@/i18n'

export default {
  name: 'BookPageContextSelectionBar',

  components: {
    'note-add-icon': NoteAdd,
    'highlight-icon': HighlightIcon,
    'lookup-icon': LookupIcon
  },

  props: {
    pageId: String
  },

  computed: {
    currentPageEditor() {
      return document.querySelectorAll(`.annotator-outer.annotator-editor`)[this.pageId === 'page_1' ? 0 : 1]
    }
  },

  methods: {
    clickHighlight () {
      this.currentPageEditor.style.display = 'none'

      setTimeout(() => {
        this.currentPageEditor.querySelector('.annotator-save').click()
      }, 50)
    },

    clickAddNote () {
      this.currentPageEditor.querySelector('.c-annotator__heading-text').innerHTML = i18n.t('NEW_NOTE')
      this.currentPageEditor.style.display = 'block'
    },

    clickWordbank () {
      this.currentPageEditor.style.display = 'none'

      //link to wordbank
    },

    clickLookup () {
      this.currentPageEditor.style.display = 'none'

      this.$emit('show-lookup')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';

  .c-annotator__wrapper {
    background: $blue;
    color: $white;
    box-shadow: none;
    border-radius: 8px;
    height: auto;
    width: auto;
    margin-left: -265px;
    display: flex;

    &:before {
      content: '';
      position: absolute;
      left: calc(50% - 12px);
      background: $blue;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      width: 9px;
      height: 13px;
      bottom: -5px;
      z-index: -1;
    }
  }

  .c-annotator__button {
    border-right:1px solid $very-light-pink;
    padding: 6px 22px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    white-space: nowrap;

    &:first-child {
      border-radius: 8px 0 0 8px;
    }
    &:last-child {
      border: none;
      border-radius: 0 8px 8px 0;
    }
    &:hover {
      background-color: $lighter-dark-blue;
    }
  }
  .c-annotator__button svg {
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }
</style>
